import { ChangeDetectorRef, Directive, EventEmitter, inject, Input, Output } from '@angular/core';
import { DynamicCellComponent } from '../grid-cell/grid-cell.component';
import { CellActionType } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { CellActionData } from '../../../../../features/bizzmine/widgets/collection-list-widget/interfaces/cell-action-data';
import { CollectionListDataInstanceProperties } from '../../../../interfaces/collection-list-data-instance';
import { GridColumnBase } from 'src/app/shared/classes/list/grid-column-base';
import { GridContextPermissionsMetadata } from '../../../../../features/bizzmine/widgets/collection-list-widget/interfaces/grid-context-permissions-metadata';
import { CollectionFormField } from 'src/models/ts/collection-form-field.model';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

/**
 * Abstract cell class defining the common inputs of a cell.
 */
@Directive()
export abstract class GridCellBaseComponent<T> implements DynamicCellComponent<T> {

  public changeDetectorRef = inject(ChangeDetectorRef);

  @Input() public column: GridColumnBase;
  @Input() public formField: CollectionFormField | undefined;
  @Input() public value: T | undefined;
  public isReportControl = false;
  public enableListMultiline = false;
  @Output() public onCellAction = new EventEmitter<{
    action: CellActionType,
    data: CellActionData,
    mouseEvent?: MouseEvent
  }>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected _data: CollectionListDataInstanceProperties & { [key: string]: T; } | unknown;
  protected _metaData: GridContextPermissionsMetadata;

  public get data(): CollectionListDataInstanceProperties & { [key: string]: T; } {
    return this._data as CollectionListDataInstanceProperties & { [key: string]: T; };
  }

  @Input({ required: true })
  public set data(value: CollectionListDataInstanceProperties & { [key: string]: T; }) {
    this._data = value;
    this.onDataChanged();
  }

  public get metaData(): GridContextPermissionsMetadata {
    return this._metaData;
  }

  @Input()
  public set metaData(value: GridContextPermissionsMetadata) {
    if (this._metaData != value) {
      this._metaData = value;
      this.onDataChanged();
    }
  }

  protected onDataChanged(): void {
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

}